module.exports = __webpack_public_path__ + "static/media/logo-play-market.229b15a5.svg";